// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type Scope } from "~/hooks/useScope";
import { APPLY_EXCEPTION_MUTATION } from "./action";

export function canApplyExceptionMutation(scope: Scope): boolean {
  return scope.iamActions.includes(APPLY_EXCEPTION_MUTATION);
}
